import { createFileRoute } from "@tanstack/react-router";

import SyncsApply from "@/features/syncs/SyncsApply";
import SideNavLayout from "@/layouts/SideNavLayout";
import { SyncsMenu } from "@/layouts/SubSideNavMenus";

export const Route = createFileRoute("/_auth/syncs/apply/")({
  component: () => (
    <SideNavLayout menu={<SyncsMenu />}>
      <SyncsApply key="create" />
    </SideNavLayout>
  ),
});
